import { Injectable } from '@angular/core';

/*
  Generated class for the TokenStorage provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
@Injectable()
export class TokenStorage {
  private tokenStorageKey = 'token';
  private storage: Storage = localStorage;

  constructor() {
    console.log('Hello TokenStorage Provider');
  }

  /*
   * Returns the current token value.
   */
  getToken(): string {
    return this.storage.getItem(this.tokenStorageKey);
  }

  /*
   * Set the token value.
   */
  setToken(token: string): void {
    console.count('TokenStorage.setToken');
    return this.storage.setItem(this.tokenStorageKey, token);
  }

  /*
   * Removes the token.
   */
  removeToken(): void {
    this.setToken('');
    return this.storage.removeItem(this.tokenStorageKey);
  }

}



// WEBPACK FOOTER //
// ./src/providers/token-storage.ts